import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { BehaviorSubject } from "rxjs";
import { SessionDataService } from "./session-data.service";
import { HistoryClient, WebTransaction } from "src/app/models";

@Injectable({
    providedIn: "root",
})
export class TransactionsService
{

    branchCustId: string;

    private recentTransactionsSubject: BehaviorSubject<WebTransaction[]> = new BehaviorSubject<WebTransaction[]>(null);
    public recentTransactions: Observable<WebTransaction[]> = this.recentTransactionsSubject.asObservable();

    constructor(
        private historyClient: HistoryClient,
    ) { }

    public getRecentHistory(branchCustId: string, numberOfRecords?: number, notesOption?: number)
    {
        this.historyClient.getRecentHistoryWeb(branchCustId, numberOfRecords, notesOption)
            .subscribe(history => this.recentTransactionsSubject.next(history));
    }
}
